/**
 * A2UI TextInput Component
 * Text input field with data binding support
 */

import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const A2UITextInput = ({ 
  label,
  placeholder,
  value,
  dataBinding,
  inputType = 'text',
  multiline = false,
  rows = 3,
  required = false,
  disabled = false,
  maxLength,
  minLength,
  pattern,
  helperText,
  errorText,
  action,
  style,
  resolveValue,
  onDataChange,
  onAction,
  surfaceId,
  componentId
}) => {
  const resolvedLabel = resolveValue ? resolveValue(label, surfaceId) : label?.literalString || '';
  const resolvedPlaceholder = resolveValue ? resolveValue(placeholder, surfaceId) : placeholder?.literalString || '';
  const resolvedValue = resolveValue ? resolveValue(value || dataBinding, surfaceId) : '';
  const resolvedDisabled = resolveValue ? resolveValue(disabled, surfaceId) : disabled?.literalBoolean || false;
  const resolvedHelper = resolveValue ? resolveValue(helperText, surfaceId) : helperText?.literalString || '';
  const resolvedError = resolveValue ? resolveValue(errorText, surfaceId) : errorText?.literalString || '';
  
  const [localValue, setLocalValue] = useState(resolvedValue || '');

  useEffect(() => {
    setLocalValue(resolvedValue || '');
  }, [resolvedValue]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    
    // Update data model if binding exists
    if (dataBinding?.path && onDataChange) {
      onDataChange(surfaceId, dataBinding.path, newValue);
    }
  };

  const handleBlur = () => {
    // Trigger action on blur if configured
    if (action && onAction) {
      onAction({
        name: action.name,
        surfaceId,
        sourceComponentId: componentId,
        context: action.context,
        timestamp: new Date().toISOString()
      });
    }
  };

  const inputProps = {
    type: inputType,
    placeholder: resolvedPlaceholder,
    value: localValue,
    onChange: handleChange,
    onBlur: handleBlur,
    disabled: resolvedDisabled,
    required,
    maxLength,
    minLength,
    pattern,
    isInvalid: !!resolvedError,
  };

  return (
    <Form.Group className="a2ui-text-input mb-3" style={style}>
      {resolvedLabel && (
        <Form.Label>{resolvedLabel}</Form.Label>
      )}
      {multiline ? (
        <Form.Control 
          as="textarea" 
          rows={rows}
          {...inputProps}
        />
      ) : (
        <Form.Control {...inputProps} />
      )}
      {resolvedError && (
        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
          {resolvedError}
        </Form.Control.Feedback>
      )}
      {resolvedHelper && !resolvedError && (
        <Form.Text className="text-muted">
          {resolvedHelper}
        </Form.Text>
      )}
    </Form.Group>
  );
};

export default A2UITextInput;
